/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationV2BatchRequest {
    getFixupPrototypeFunction() { return RecommendationV2BatchRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendationV2BatchRequest>): RecommendationV2BatchRequest {
        let obj = Object.assign(new RecommendationV2BatchRequest(), model);
        RecommendationV2BatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationV2BatchRequest>): RecommendationV2BatchRequest {
        if (!model) return null;
        return RecommendationV2BatchRequest.newInstance(<RecommendationV2BatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationV2BatchRequest) {
        if (!obj) return;

        models.RecommendationV2BatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationV2BatchRequest): boolean {
        Object.setPrototypeOf(obj, RecommendationV2BatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendation_ids) {
            models.BatchRequest.fixupPrototype(this.recommendation_ids);
        }
    }

    /**
     * ids for the recommendation
     */
    recommendation_ids: models.BatchRequest;

    /**
     * Bool determines whether the requested ids are retrieved from open or realized
     */
    for_open_recommendation: boolean = false;

    /**
     * workflow sys id for which the rules are required
     */
    workflow_sys_id: string;

    /**
     * over all status of the workflow.
     */
    workflow_status: models.WorkFlowImpactStatus;

}
